import Axios from "../config/config";

export const GENERATE_LIVE_TEST_RESULT = async (body) => {
    try {
        const response = await Axios.post('generate-live-test-result/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};